import { contentFetch } from "../contentClient.js";
import {
    resolveScopedIdArgs,
    resolveScopedLinkArgs,
    resolveScopedLinkPayloadArgs,
    resolveScopedListArgs,
    resolveScopedMutationArgs,
    resolveScopedPayloadArgs,
    resolveScopedRenameArgs,
    resolveScopedValueArgs,
} from "./scope.js";

// ============= Items API (v2) =============

const base = (projectId, versionId) =>
    `/api/v2/projects/${projectId}/versions/${versionId}/entities`;

export async function getItems({ projectId, versionId, search, parameterGroupId, page = 1, pageSize } = {}, init) {
    ({ args: { projectId, versionId, search, parameterGroupId, page, pageSize }, init } = resolveScopedListArgs({ projectId, versionId, search, parameterGroupId, page, pageSize }, init));
    const params = { page };
    if (pageSize) params.pageSize = pageSize;
    if (search?.trim()) params["filter.systemName:contains"] = search.trim();
    if (parameterGroupId) params["filter.parameterGroupId"] = parameterGroupId;
    return contentFetch(base(projectId, versionId), { params, ...(init || {}) });
}

export async function getItemById(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}`, init);
}

export async function createItem(projectId, versionId, payload, init) {
    ({ projectId, versionId, payload, init } = resolveScopedPayloadArgs(projectId, versionId, payload, init));
    // payload: { systemName, name, description }
    return contentFetch(base(projectId, versionId), {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

export async function patchItem(projectId, versionId, id, payload, init) {
    ({ projectId, versionId, id, payload, init } = resolveScopedMutationArgs(projectId, versionId, id, payload, init));
    // payload: { nameRefId?, descriptionRefId?, name?, description? }
    return contentFetch(`${base(projectId, versionId)}/${id}`, {
        method: "PATCH",
        body: payload,
        ...(init || {}),
    });
}

export async function renameItemSystemName(projectId, versionId, id, newSystemName, init) {
    ({ projectId, versionId, id, newSystemName, init } = resolveScopedRenameArgs(projectId, versionId, id, newSystemName, init));
    return contentFetch(`${base(projectId, versionId)}/${id}:rename`, {
        method: "POST",
        body: { newSystemName },
        ...(init || {}),
    });
}

export async function deleteItem(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}`, {
        method: "DELETE",
        ...(init || {}),
    });
}

// --- Parameter groups ---

export async function getItemParameterGroups(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/parameter-groups`, init);
}

export async function attachParameterGroupToItem(projectId, versionId, id, payload, init) {
    ({ projectId, versionId, id, payload, init } = resolveScopedMutationArgs(projectId, versionId, id, payload, init));
    // payload: { parameterGroupId, orderIndex? }
    return contentFetch(`${base(projectId, versionId)}/${id}/parameter-groups`, {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

export async function patchItemParameterGroupLink(projectId, versionId, id, linkId, payload, init) {
    ({ projectId, versionId, id, linkId, payload, init } = resolveScopedLinkPayloadArgs(projectId, versionId, id, linkId, payload, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/parameter-groups/${linkId}`, {
        method: "PATCH",
        body: payload,
        ...(init || {}),
    });
}

export async function detachParameterGroupFromItem(projectId, versionId, id, linkId, init) {
    ({ projectId, versionId, id, linkId, init } = resolveScopedLinkArgs(projectId, versionId, id, linkId, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/parameter-groups/${linkId}`, {
        method: "DELETE",
        ...(init || {}),
    });
}

// --- Values ---

export async function getItemValues(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/values`, init);
}

export async function setItemValue(projectId, versionId, id, parameterId, payload, init) {
    ({ projectId, versionId, id, parameterId, payload, init } = resolveScopedValueArgs(projectId, versionId, id, parameterId, payload, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/values/${parameterId}`, {
        method: "PUT",
        body: payload,
        ...(init || {}),
    });
}

export async function deleteItemValue(projectId, versionId, id, parameterId, init) {
    ({ projectId, versionId, id, parameterId, init } = resolveScopedValueArgs(projectId, versionId, id, parameterId, undefined, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/values/${parameterId}`, {
        method: "DELETE",
        ...(init || {}),
    });
}
